import { Box } from '@mantine/core';

import { SectionLabel } from 'components';
import classes from './index.module.css';

interface IStep {
    text: string;
}

const Step = ({ text }: IStep) => {
    return (
        <Box className={classes.step}>
            <SectionLabel label={text} weight={300}></SectionLabel>
        </Box>
    )
}

export default Step;